import Doughnut from "libs/preact-chart/Doughnut";
import ChartCard from "components/Chart/ChartCard";

const options = {
  responsive: true,
  maintainAspectRatio: false,
};

function DoughnutChart({ data, name, getReport }) {
  const dataSet = [
    {
      label: "Valor",
      data: data.values,
      backgroundColor: ["rgba(141, 193, 75, 0.6)", "rgba(255, 255, 255, 0.6)"],
      borderColor: ["rgba(141, 193, 75, 1)", "rgba(150, 150, 150, 1)"],
      borderWidth: 1,
    },
  ];

  const height = 285;
  const refName = "doughnut-chart-presik";
  return (
    <ChartCard
      header={name}
      header_meta={data.header_meta}
      desc={data.desc}
      desc_meta={data.desc_meta}
      getReport={getReport}
    >
      <div className="chart-segment-container">
        <Doughnut
          refName={refName}
          labels={data.labels}
          dataSet={dataSet}
          options={options}
          height={height}
        />
      </div>
      <div className="text-center text-3xl text-cyan-600">
        {data.center_label}
      </div>
    </ChartCard>
  );
}

export default DoughnutChart;
